'use client';

import { cn } from '@noirproperties/ui/lib/utils';
import Image from 'next/image';

type ImageSectionProps = {
  alt: string;
  poster: string;
  children?: React.ReactNode;
};

export function ImageSection({
  alt,
  poster,
  children,
}: ImageSectionProps) {
  return (
    <section
      className={cn(
        `relative h-svh w-full overflow-hidden pt-48 before:absolute before:inset-0 before:z-20 before:h-80 before:w-full before:bg-gradient-to-b before:from-neutral-900/50 after:absolute after:inset-0 after:-z-10 after:h-screen after:w-full after:bg-neutral-950 after:opacity-75 sm:pt-48 lg:pt-56 lg:after:w-2/3 lg:after:opacity-80 lg:after:[clip-path:polygon(0%_0%,_100%_0%,90%_100%,_0%_100%)] lg:after:rtl:[clip-path:polygon(0%_0%,_100%_0%,_100%_100%,_10%_100%)]`,
      )}
      id="video"
    >
      <div className="z-30 mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
          <div className="px-6 py-24 sm:py-40 lg:px-8 lg:py-56 lg:pe-0">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-2xl">
              {children}
            </div>
          </div>

          <div className="absolute inset-0 -z-10 h-full w-full overflow-hidden bg-gunmetal object-cover object-center">
            <Image
              alt={alt}
              className="h-full w-full object-cover object-center"
              fill
              sizes="100vw"
              src={poster}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
